export default __webpack_public_path__ + "static/media/whale_main_logo.30e799f6.svg";